import React from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'antd';
import { NAV_LIST } from '../../config/constants';
import { removeCookie, getCookie } from '../../common/utils';

const DropDownMenu = () => {
	const List = NAV_LIST.map((item) => (
		<Menu.Item key={item.name}>
			<Link to={item.url}>{item.name}</Link>
		</Menu.Item>
	));
	const email = getCookie('email');
	return (
		<Menu>
			{List}
			<Menu.Item>
				<Link to="/mypage">Profile</Link>
			</Menu.Item>
			<Menu.Item>
                <Link to="mypage/modify-password">Security</Link>
            </Menu.Item>
            <Menu.Item>
                <Link to="/mypage/apikey">Exchange Key</Link>
            </Menu.Item>
			<Menu.Item>
				<Link to="/help">Help</Link>
			</Menu.Item>
			{email ? (
				<Menu.Item style={{ borderTop: '1px solid #d9d9d9' }}>
					<Link
						to={{ pathname: '/', state: { isLogout: true } }}
						onClick={() => {
							removeCookie('id_token');
							removeCookie('email');
						}}
					>
						Logout
					</Link>
				</Menu.Item>
			) : (
				<Menu.Item style={{ borderTop: '1px solid #d9d9d9' }}>
					<Link to={{ pathname: '/' }}>Login</Link>
				</Menu.Item>
			)}
		</Menu>
	);
};

export const LoginDropDown = () => {
	return (
		<Menu>
			<Menu.Item>
				<Link to="/login">Login</Link>
			</Menu.Item>
			<Menu.Item>
				<Link to="/signup">SignUp</Link>
			</Menu.Item>
		</Menu>
	);
};

export default DropDownMenu;
